import { styled } from '@mui/material';

import { TCurrentUserTeamDto } from '@app-velocity/av-api-v2';
import { WorkspaceAvatar } from '@app-velocity/ui';

export type SingleTeamProps = {
  team: TCurrentUserTeamDto & { workspaceId: string };
};

const StyledSingleTeam = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  padding: theme.spacing(1),
}));

const TeamName = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: 13,
});

export const SingleTeam = ({ team }: SingleTeamProps) => {
  return (
    <StyledSingleTeam>
      <WorkspaceAvatar title={team.teamName || '-'} />
      <TeamName>{team.teamName}</TeamName>
    </StyledSingleTeam>
  );
};
